export default __webpack_public_path__ + "static/media/scholarship.e013ed1b.jpg";